import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

import { NeedHelpSection } from '../../../../../components/NeedHelpSection/NeedHelpSection';
import { DesktopSidePanelShell } from '../../../../components/LoanSummary/DesktopSidePanelShell';
import { SummaryLayout } from '../components/SummaryLayout';
import { useLoanSummaryData } from '../useLoanSummaryData';

export const DesktopLoanSummary = ({
    selectedOffer,
    drawdownAmount
}: {
    selectedOffer: TFormalOffer | undefined;
    drawdownAmount: number;
}) => {
    const { monthlyRepayment, fullTermRepayment } = useLoanSummaryData({
        selectedOffer,
        drawdownAmount
    });

    return (
        <DesktopSidePanelShell data-testid="desktop-loan-summary">
            <SummaryLayout
                selectedOffer={selectedOffer}
                drawdownAmount={drawdownAmount}
                monthlyRepayment={monthlyRepayment}
                fullTermRepayment={fullTermRepayment}
            />

            <div className="mt-5xl">
                <NeedHelpSection variant="offers-desktop" />
            </div>
        </DesktopSidePanelShell>
    );
};
